import React from 'react';

import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from '@material-ui/core';
import { isUndefined } from 'lodash';
import PropTypes from 'prop-types';

import * as S from './styles';

export default function Tabela({ title, cells, data, height, size }) {
  return (
    <S.WrapperTabela height={height}>
      <S.WrapperTitle>{title}</S.WrapperTitle>
      <TableContainer>
        <Table stickyHeader aria-label="sticky table" size={size}>
          <TableHead>
            <TableRow>
              {cells.map((cell, index) => (
                <TableCell
                  key={`cell-index-head-${index}`}
                  align={cell.align || 'left'}
                >
                  {cell.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((item, index) => (
              <TableRow hover tabIndex={-1} key={`table-row-body-${index}`}>
                {cells.map((cell, indexKey) => (
                  <TableCell
                    key={`table-cell-body-${indexKey}`}
                    align={cell.align || 'left'}
                  >
                    {!isUndefined(cell.rule) && cell.rule(item) ? (
                      <input
                        id={`input-${cell.id}-${index}`}
                        type="number"
                        defaultValue={item[cell.id]}
                        min="0"
                        onKeyUp={({ target, key }) =>
                          key === 'Enter' &&
                          cell.callback(target.value, index, item)
                        }
                        onBlur={({ target }) =>
                          cell.callback(target.value, index, item)
                        }
                      />
                    ) : cell.format ? (
                      cell.format(item[cell.id])
                    ) : (
                      item[cell.id]
                    )}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </S.WrapperTabela>
  );
}

Tabela.propTypes = {
  title: PropTypes.string.isRequired,
  cells: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      align: PropTypes.string,
    })
  ).isRequired,
  data: PropTypes.arrayOf(PropTypes.any).isRequired,
  height: PropTypes.string,
  size: PropTypes.oneOf(['small', 'medium']),
};

Tabela.defaultProps = {
  height: '100%',
  size: 'medium',
};
